import { useEffect } from "react";

import { setDashboardLayers as setDashboardLayersAction } from "../../ducks/dashboard/dashboard";
import { useAction } from "../useAction";
import { useWidgetConfiguration } from "../../modules/Dashboard/hooks/useWidgetConfiguration";
import { useIsDashboard } from "../location/useIsDashboard";
import { WidgetType } from "../../modules/FeatureCard/types";

export const useInitDashboardLayers = () => {
  const setDashboardLayers = useAction(setDashboardLayersAction);
  const isDashboard = useIsDashboard();
  const { currentConfig } = useWidgetConfiguration(WidgetType.Dashboard);

  useEffect(() => {
    if (!isDashboard) return;

    setDashboardLayers(
      currentConfig.layers?.length
        ? currentConfig.layers.reduce((result, layer) => {
            return { ...result, [layer.name]: { isVisible: layer.isVisible !== undefined ? layer.isVisible : true } };
          }, {})
        : {},
    );
  }, [currentConfig?.layers, isDashboard]);
};
